import { render, staticRenderFns } from "./DsParentEffectivities.vue?vue&type=template&id=4fd369c2&scoped=true"
import script from "./DsParentEffectivities.vue?vue&type=script&lang=js"
export * from "./DsParentEffectivities.vue?vue&type=script&lang=js"
import style0 from "./DsParentEffectivities.vue?vue&type=style&index=0&id=4fd369c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd369c2",
  null
  
)

export default component.exports